import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";
import AddConnectorForm from "../../components/connectors/AddConnectorForm";
import PageTitle from "../../components/common/PageTitle";
import { getConnectorProviderTile } from "../../utils/connectorDashboardConfig";
import { CONNECTORS_DASHBOARD_PATH } from "../../utils/connectorRoutes";

interface AddConnectorPageProps {
  tenantId: string | null;
}

const AddConnectorPage: React.FC<AddConnectorPageProps> = ({ tenantId }) => {
  const { providerSlug } = useParams<{ providerSlug: string }>();
  const provider = providerSlug
    ? getConnectorProviderTile(providerSlug)
    : undefined;

  if (!providerSlug) {
    return <Navigate to={CONNECTORS_DASHBOARD_PATH} replace />;
  }

  if (!provider) {
    return (
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
        <PageTitle
          pageTitle="Unknown provider"
          pageDescription="The requested API management provider is not supported."
        />
        <Container maxWidth="sm" sx={{ py: 4 }}>
          <Typography color="text.secondary" align="center">
            No connector type matches &quot;{providerSlug}&quot;.
          </Typography>
        </Container>
      </Box>
    );
  }

  return <AddConnectorForm provider={provider} tenantId={tenantId} />;
};

export default AddConnectorPage;
